// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2TT-I","title":"Info_title__3zUDa","selects":"Info_selects__3h20W","requiredAsterisk":"Info_requiredAsterisk__132cq"};